import { addDoc, collection, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { CreateThemeTag, ThemeTag } from "../types";
import { ThemeTagDB } from "./ThemeTagDB";

export const createThemeTag = async (
  themeTag: CreateThemeTag,
): Promise<ThemeTag> => {
  const collectionRef = collection(db, "themeTags");

  const themeTagRef = await addDoc(collectionRef, {
    ...themeTag,
    createdAt: new Date(),
  });

  const newThemeTagSnapshot = await getDoc(themeTagRef);

  const newThemeTag = new ThemeTagDB(newThemeTagSnapshot);

  return newThemeTag.toThemeTag();
};
